export default __webpack_public_path__ + "static/chaos-121b2b1c7b1f719e20be188152e2008a.png";